// extracted by mini-css-extract-plugin
export var xs = "375";
export var sm = "576";
export var md = "768";
export var lg = "992";
export var xl = "1200";
export var xxl = "1440";
export var fhd = "1921";
export var threeIconCardRowContainer = "IconCardRow-module--threeIconCardRowContainer--1i36B";
export var fourIconCardRowContainer = "IconCardRow-module--fourIconCardRowContainer--Jx8Ts";